import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    locations: Array
  }

  connect() {    
    console.log(this.locationsValue);

    // The map, centered at the first location
    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: {lat: 25.2761838, lng: 55.2883546},
        mapId: "map" // Required for AdvancedMarkerElement
    });

    // Add markers for each location
    this.locationsValue.forEach((location) => {
        // Create a colored pin
        const pin = new google.maps.marker.PinElement({
            background: (!location.hidden ? '#FF0000' : '#d3d3d3'), 
            borderColor: '#FFFFFF', // White border
            glyphColor: '#FFFFFF', // White glyph/text color
            scale: 1.2 // Optional: make it bigger
        });

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: location.title,
            content: pin.element
        });

        // Create info window
        const infoWindow = new google.maps.InfoWindow({
            content: '<strong>' + location.title + '</strong>'
        });

        // Add click listener
        marker.addListener('click', () => {
            infoWindow.open({
                anchor: marker,
                map: map
            });
        });
    });
  }
}